<template>
  <div class="form-check form-check-inline" :class="{'is-invalid': invalid}" v-for="(option, index) in options" :key="index">
    <input
      class="form-check-input"
      type="checkbox"
      :class="{'is-invalid': invalid}"
      :id="option.id"
      :checked="modelValue?.[option.id] === true"
      @change="doChange(option.id, $event.target.checked)"
    >
    <label class="form-check-label" :for="option.id">{{ option.text }}</label>
  </div>
</template>
<script>
export default {
  name: 'CheckBoxes',
  props: {
    modelValue: {
      type: Object,
      default: () => {return {}},
    },
    options: {
      type: Array,
      required: true
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    doChange(id, value) {
      let changedValue = this.modelValue;
      changedValue[id] = value;
      this.$emit('update:modelValue', changedValue);
    }
  },
}
</script>
